export default __webpack_public_path__ + "static/Logo Messaging Platform 1280x453-416d779b8a709d3d341dd1c939ce318e.jpg";